import { createSlice } from '@reduxjs/toolkit';
import { fetchUserEntries } from '../thunks/entriesThunk';

const initialState = {
  entries: [],
  loading: false,
  error: null
};

const entriesSlice = createSlice({
  name: 'entries',
  initialState,
  reducers: {
    clearEntries: (state) => {
      state.entries = [];
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserEntries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserEntries.fulfilled, (state, action) => {
        state.loading = false;
        state.entries = action.payload;
      })
      .addCase(fetchUserEntries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearEntries } = entriesSlice.actions;
export default entriesSlice.reducer;
